import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setReduxLocale } from '../../store';
import { useCookies } from 'react-cookie';
import LanguageList from '../../components/switchLanguage';
import { gaChangeLanguage } from '../../services/analitics';

export const SwitchLanguage = () => {
  const setCookies = useCookies(['userLocale'])[1];
  const { supportedLanguages, userLocale } = useSelector(
    (state) => state.config
  );
  const dispatch = useDispatch();

  function setLocale(lang) {
    if (lang !== userLocale) {
      setCookies('userLocale', lang);
      dispatch(setReduxLocale(lang));
      gaChangeLanguage(lang);
    }
  }

  return <LanguageList action={setLocale} languages={supportedLanguages} />;
};
